export default "__VITE_ASSET__$seKct1f__"